import { Pipe, PipeTransform } from '@angular/core';

@Pipe({
  name: 'join',
  standalone: true,
})
export class JoinPipe implements PipeTransform {
  /**
   * Transforms an array into a joined string with the specified separator.
   * @param value The array to join.
   * @param separator The separator to use (default is ',').
   * @returns The joined string.
   */
  transform(value: any[], separator = ', '): string {
    if (!Array.isArray(value)) {
      return '';
    }
    return value.join(separator);
  }
}
